export default __webpack_public_path__ + "static/media/vind-pages.430fec82.svg";